export type TradeCovers = {
  [key: string]: string[];
};

export const tradeCovers: TradeCovers = {
  "Accident investigator": ["Legal expenses", "Personal accident"],
  Accountant: ["Legal expenses", "Excess sum insured"],
  "Accumulator/Battery Manufacturing": [
    "Legal expenses",
    "Include stock online",
  ],
  "Acoustic engineer": ["Personal accident", "Legal expenses"],
  "Actor (excluding stunt work)": ["Personal accident", "Include contents"],
  Acupuncture: ["Personal accident", "Excess sum insured"],
  Administrator: ["Legal expenses", "Include contents"],
  "Advertising agent": ["Legal expenses", "Include contents"],
  "Aerial & satellite dish erectors - residential only": [
    "Personal accident",
    "Include tools",
  ],
  "Aerial erector - non residential": [
    "Include contents",
    "Excess sum insured",
  ],
  "Agricultural Equipment Manufacturers": ["Include stock online"],
  "Agricultural contractors (excluding crop spraying)": [
    "Personal accident",
    "Legal expenses",
  ],
  "Air conditioning installation": ["Personal accident", "Legal expenses"],
  "Alarm installers": ["Personal accident", "Legal expenses"],
  "Animal breeder": ["Legal expenses", "Excess sum insured"],
  "Animal owners club": ["Excess sum insured"],
  "Antique Book Shop": ["Include stock online", "Include contents"],
  "Antique Furniture Shop": ["Include contents", "Include stock online"],
  "Antique Shop": ["Include stock online", "Include contents"],
  "Antique dealer": ["Include stock online", "Legal expenses"],
  "Antiques & collectables in Shops & retail": ["Excess sum insured"],
  "Appliance repairers - domestic": ["Excess sum insured", "Legal expenses"],
  "Appliances Shop": ["Include contents", "Include stock online"],
  "Aquarium / Tropical Fish Shop": ["Legal expenses", "Business interruption"],
  Arbitrator: ["Excess sum insured", "Include contents"],
  Architect: ["Legal expenses", "Include contents"],
  "Architect technician": ["Legal expenses", "Excess sum insured"],
  "Army & Navy Shop": ["Legal expenses", "Include stock online"],
  Aromatherapy: ["Legal expenses", "Include stock online"],
  "Art dealer": ["Legal expenses", "Include stock online"],
  "Art gallery": ["Legal expenses", "Excess sum insured"],
  Artist: ["Include stock online", "Include contents"],
  "Artist Studio": ["Include contents", "Include stock online"],
  "Artistic painters, sculptors or potters": [
    "Include stock online",
    "Personal accident",
  ],
  "Artists Materials": ["Include stock online"],
  "Artists studio": ["Include contents", "Legal expenses"],
  "Arts & Crafts Ex. Precious Stones / Gift Shop": [
    "Include stock online",
    "Include contents",
  ],
  "Arts & Crafts Shop": ["Include stock online", "Include contents"],
  "Arts & crafts in Shops & retail": ["Excess sum insured", "Include contents"],
  "Au pair": ["Legal expenses", "Excess sum insured"],
  Auctioneer: ["Personal accident", "Legal expenses"],
  "Audio Visual Media Wholesaling": ["Include stock online"],
  "Auditor (non-accountant)": ["Legal expenses", "Personal accident"],
  Author: ["Legal expenses", "Include stock online"],
  "Baby Goods Shop": ["Legal expenses", "Include stock online"],
  "Babywear Shop": ["Legal expenses", "Include stock online"],
  Bailiff: ["Legal expenses", "Excess sum insured"],
  Baker: ["Include contents", "Legal expenses"],
  Bakery: ["Include contents", "Legal expenses"],
  "Bakery / Café": ["Include contents", "Include stock online"],
  "Bakery Produce Manufacturing": ["Legal expenses", "Include stock online"],
  "Balloons / Party Supplies": ["Include contents", "Include stock online"],
  "Balloons and party supplies in Shops & retail": ["Include contents"],
  Barber: ["Include tools", "Personal accident"],
  "Barber / Beauty Salon": ["Include contents", "Personal accident"],
  "Barber Shop": ["Include contents", "Personal accident"],
  "Barber in Shops & retail": ["Excess sum insured", "Include contents"],
  Barrister: ["Include contents", "Legal expenses"],
  "Bathroom & kitchen design": ["Legal expenses", "Personal accident"],
  "Bathroom Equipment Shop": ["Include contents", "Personal accident"],
  "Bathroom, bedroom & kitchen fitter": ["Legal expenses", "Personal accident"],
  Beautician: ["Legal expenses", "Include tools"],
  "Beauty Products": ["Include stock online", "Legal expenses"],
  "Beauty Salon": ["Include contents", "Include stock online"],
  "Beauty Salon / Hairdressing": ["Include contents", "Include stock online"],
  "Beauty Shop": ["Include contents", "Include stock online"],
  "Beauty products in Shops & retail": ["Excess sum insured"],
  "Beauty salon & hairdressing in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Beauty salon in Shops & retail": ["Excess sum insured", "Include contents"],
  "Bed & Breakfast - Licensed": ["Include stock online", "Include contents"],
  "Bed & Breakfast - Unlicensed": ["Include contents", "Personal accident"],
  "Bed Shop": ["Include stock online", "Legal expenses"],
  "Bedding Shop": ["Include stock online", "Include contents"],
  "Beer Warehousing": ["Legal expenses", "Include stock online"],
  "Bicycle Rental Shop": ["Include stock online", "Business interruption"],
  "Bicycle Repair Shop": ["Include stock online", "Include contents"],
  "Bicycle Repair Shop in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Bicycle Shop": ["Include stock online", "Include contents"],
  "Bicycle repairs (including e-bikes)": ["Legal expenses", "Include tools"],
  "Blind / curtain makers & fitters": ["Personal accident", "Legal expenses"],
  "Book Manufacturers": ["Include stock online"],
  "Book in Shops & retail": ["Excess sum insured"],
  "Book keeper": ["Legal expenses", "Include contents"],
  "Bookmaker in Shops & retail": ["Excess sum insured"],
  Bookshop: ["Include stock online", "Include contents"],
  "Bookshop - Inc Second Hand": ["Include stock online"],
  "Boot & Shoe Shop": ["Include stock online", "Business interruption"],
  "Bottle (Plastic) Wholesalers": ["Include stock online"],
  "Breeder (animal)": ["Legal expenses", "Excess sum insured"],
  Brewery: ["Include buildings", "Include stock online"],
  "Bric A Brac": ["Include stock online", "Include contents"],
  Bricklayer: ["Personal accident", "Legal expenses"],
  "Bridal Shop": ["Include stock online", "Include contents"],
  "Bridal Shop in Shops & retail": ["Include contents", "Excess sum insured"],
  Builder: ["Personal accident", "Legal expenses"],
  "Builder - design only": ["Personal accident", "Legal expenses"],
  "Builder - private dwelling houses alteration & repair": [
    "Excess sum insured",
    "Legal expenses",
  ],
  "Builders & contractors in Industrial units": ["Excess sum insured"],
  "Builders Merchant": ["Legal expenses", "Personal accident"],
  "Building Material Wholesaling": ["Legal expenses", "Include stock online"],
  "Building Society in Shops & retail": ["Excess sum insured"],
  "Building services engineer": ["Legal expenses", "Personal accident"],
  Bungalow: ["Legal expenses", "Include contents"],
  "Burger Bar": ["Include contents", "Excess sum insured"],
  "Business analyst": ["Legal expenses", "Portable equipment"],
  "Business coach": ["Legal expenses", "Include contents"],
  "Business consultant": ["Legal expenses", "Portable equipment"],
  Butcher: ["Include contents", "Include stock online"],
  "Butcher & Greengrocer in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Butcher & Grocer Unlicensed in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  "Butcher / Greengrocer": ["Include contents", "Include stock online"],
  "Butcher / Grocer - Unlicensed": ["Include stock online", "Include contents"],
  "Butchers - Wholesale": ["Include stock online"],
  "Cable laying": ["Personal accident", "Excess sum insured"],
  Café: ["Include contents", "Include stock online"],
  "Café / Coffee Shop": ["Include contents", "Include stock online"],
  "Café / Gift Shop": ["Include stock online", "Legal expenses"],
  "Café / Licenced Premises": ["Include contents", "Include stock online"],
  "Café / Sandwich Bar": ["Include contents", "Legal expenses"],
  "Café / Take Away Food": ["Include contents", "Include stock online"],
  "Cafés - excluding deep fat frying in Food & drink": [
    "Excess sum insured",
    "Include contents",
  ],
  "Cafés - including deep fat frying in Food & drink": [
    "Excess sum insured",
    "Include contents",
  ],
  "Cake maker and decorator": ["Legal expenses", "Personal accident"],
  Calibration: ["Include tools"],
  Calligraphist: ["Excess sum insured", "Include stock online"],
  "Camera Shop": ["Include stock online", "Excess sum insured"],
  "Camping & Outdoor Shop": ["Legal expenses", "Include contents"],
  "Candle / wax melt maker": ["Legal expenses", "Include stock online"],
  "Car Accessory Dealing": ["Include buildings", "Include stock online"],
  "Car Accessory Shop": ["Legal expenses", "Include stock online"],
  "Car Accessory Shop in Shops & retail": ["Include contents"],
  "Car Entertainment System Shop": ["Legal expenses", "Excess sum insured"],
  "Car Parts & Accessories Shop": ["Include contents", "Include stock online"],
  "Car Parts & Accessories Shop in Shops & retail": ["Excess sum insured"],
  "Car Parts Shop": ["Include contents", "Include stock online"],
  "Car Stereo Shop - Including Fitting": ["Personal accident"],
  "Car park operator": ["Personal accident", "Legal expenses"],
  "Car valeter": ["Legal expenses", "Excess sum insured"],
  "Card & Bookshop": ["Include contents", "Include stock online"],
  Carer: ["Personal accident", "Legal expenses"],
  Caretaker: ["Personal accident", "Legal expenses"],
  Carpenter: ["Personal accident", "Legal expenses"],
  "Carpet Shop": ["Include stock online", "Include contents"],
  "Carpet Shop - Oriental Or Persian": ["Include contents"],
  "Carpet Warehouse": ["Legal expenses", "Include stock online"],
  "Carpet fitter": ["Legal expenses", "Personal accident"],
  "Carpet, upholstery & curtain cleaner": [
    "Include tools",
    "Excess sum insured",
  ],
  "Carpets in Shops & retail": ["Include contents"],
  Cartographer: ["Legal expenses"],
  "Cash & Carry": ["Include contents", "Business interruption"],
  "Catalogue goods distributor": ["Legal expenses", "Excess sum insured"],
  "Caterer - excluding mobile vans": ["Legal expenses", "Personal accident"],
  "Caterer - including mobile vans": ["Legal expenses", "Excess sum insured"],
  "Catering - Licensed": ["Include stock online"],
  "Cavity insulation": ["Include tools", "Personal accident"],
  "Cctv installation": ["Personal accident", "Legal expenses"],
  "Cd & Dvd Shop": ["Legal expenses"],
  "Ceiling contractors": ["Legal expenses", "Include contract works"],
  "Ceramics Shop": ["Include stock online", "Legal expenses"],
  "Chandelier Shop": ["Include contents", "Business interruption"],
  "Chandlery Shop": ["Include contents", "Legal expenses"],
  "Charity Shop": ["Legal expenses", "Include contents"],
  "Charity Shop in Shops & retail": ["Excess sum insured", "Include contents"],
  "Chartered valuer": ["Personal accident", "Legal expenses"],
  Chauffeur: ["Legal expenses", "Excess sum insured"],
  "Cheese Wholesalers": ["Include stock online"],
  Chef: ["Personal accident", "Legal expenses"],
  "Child minder": ["Legal expenses", "Personal accident"],
  "Children's Clothes Shop": ["Include stock online", "Include contents"],
  "Childrens entertainer": ["Legal expenses", "Include contents"],
  "Chimney sweep": ["Include tools", "Legal expenses"],
  "China / Glassware Retailing": ["Excess sum insured", "Include contents"],
  Chiropodist: ["Legal expenses", "Personal accident"],
  Chiropractor: ["Include contents", "Legal expenses"],
  "Chocolate Wholesalers": ["Include stock online", "Legal expenses"],
  Chocolatier: ["Include contents", "Legal expenses"],
  "Christmas Goods Shop": ["Excess sum insured", "Include contents"],
  "Christmas tree seller": ["Excess sum insured", "Legal expenses"],
  Church: ["Legal expenses", "Personal accident"],
  Cladding: ["Personal accident", "Excess sum insured"],
  "Cleaner - domestic": ["Personal accident", "Excess sum insured"],
  "Cleaner - drains": ["Personal accident", "Excess sum insured"],
  "Cleaner - office": ["Personal accident", "Legal expenses"],
  "Cleaner - other": ["Personal accident", "Legal expenses"],
  "Clerical / secretarial services": ["Legal expenses", "Include contents"],
  "Clock & Watch Repair": ["Include contents", "Include stock online"],
  "Clock & Watch Sales": ["Include stock online", "Legal expenses"],
  "Clothing Accessories Manufacturers (Fabric)": [
    "Include stock online",
    "Legal expenses",
  ],
  "Clothing Accessories Wholesalers (Fabric)": [
    "Include stock online",
    "Personal accident",
  ],
  "Clothing Accessories Wholesaling": [
    "Include stock online",
    "Include buildings",
  ],
  "Clothing Shop": ["Include stock online", "Include contents"],
  "Clothing Shop / Fashion Accessories": [
    "Include stock online",
    "Include contents",
  ],
  "Clothing Shop / Gift Shop": ["Include stock online", "Include contents"],
  "Clothing in Shops & retail": ["Excess sum insured", "Include contents"],
  "Coffee Merchant": ["Include stock online", "Legal expenses"],
  "Coffee Shop": ["Include contents", "Include stock online"],
  "Coffee Shop / Delicatessen": ["Business interruption", "Include contents"],
  "Coffee Shop / Gift Shop": ["Include contents", "Include stock online"],
  "Coffee Shop / Sandwich Bar": ["Include contents", "Legal expenses"],
  "Coffee Shop / Sandwich Bar in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Coffee shop in Food & drink": ["Include contents", "Excess sum insured"],
  "Community action group": ["Legal expenses"],
  "Complaints handling": ["Legal expenses", "Excess sum insured"],
  "Complementary therapist": ["Legal expenses", "Personal accident"],
  "Computer - General / Computer Supplies": [
    "Legal expenses",
    "Include stock online",
  ],
  "Computer - General / Mobile Phone": [
    "Include stock online",
    "Legal expenses",
  ],
  "Computer Cabling": ["Excess sum insured", "Legal expenses"],
  "Computer Consumables Sales": ["Legal expenses", "Include contents"],
  "Computer Games Shop": ["Include contents", "Include stock online"],
  "Computer Hardware & Software Installation": [
    "Legal expenses",
    "Portable equipment",
  ],
  "Computer Programmer": ["Legal expenses", "Portable equipment"],
  "Computer Repair": ["Include contents", "Legal expenses"],
  "Computer Shop": ["Business interruption", "Include contents"],
  "Computer Software Customisation": ["Excess sum insured", "Legal expenses"],
  "Computer Software Developers": ["Legal expenses", "Excess sum insured"],
  "Computer Software Maintenance": ["Include contents", "Excess sum insured"],
  "Computer Software Sale (Third Party)": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Computer Software Testing": ["Portable equipment", "Legal expenses"],
  "Computers - Hardware Wholesaling": ["Include stock online"],
  "Concrete contractor": ["Personal accident", "Legal expenses"],
  "Confectionary Shop": ["Include stock online", "Include contents"],
  "Confectioners/Sweets in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  "Confectionery (Sweets) Wholesalers": ["Legal expenses"],
  "Confectionery Manufacturing": ["Include stock online"],
  "Conference & exhibition organiser": ["Legal expenses", "Excess sum insured"],
  "Conservatory Retailer": ["Personal accident", "Legal expenses"],
  "Conservatory installers": ["Personal accident", "Include tools"],
  "Consultant - Computer Hardware": ["Legal expenses", "Excess sum insured"],
  "Consultant - Computer Software": ["Legal expenses", "Excess sum insured"],
  "Consultant - Database Management": ["Legal expenses", "Portable equipment"],
  "Consultant - Internet": ["Portable equipment", "Personal accident"],
  "Consultant - acoustic": ["Personal accident", "Legal expenses"],
  "Consultant - agriculture": ["Legal expenses", "Personal accident"],
  "Consultant - air conditioning": ["Include tools", "Personal accident"],
  "Consultant - automation": ["Legal expenses", "Personal accident"],
  "Consultant - aviation": ["Personal accident", "Legal expenses"],
  "Consultant - brand & design": ["Legal expenses", "Include contents"],
  "Consultant - brewers": ["Legal expenses", "Personal accident"],
  "Consultant - building": ["Legal expenses", "Excess sum insured"],
  "Consultant - business & management": [
    "Legal expenses",
    "Portable equipment",
  ],
  "Consultant - debt management": ["Legal expenses", "Excess sum insured"],
  "Consultant - drainage": ["Legal expenses", "Personal accident"],
  "Consultant - education": ["Legal expenses", "Include contents"],
  "Consultant - electronics": ["Legal expenses", "Personal accident"],
  "Consultant - employment": ["Legal expenses", "Excess sum insured"],
  "Consultant - energy (incl carbon credit trading)": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Consultant - energy conservation": ["Legal expenses", "Excess sum insured"],
  "Consultant - engineer": ["Legal expenses", "Excess sum insured"],
  "Consultant - environment": ["Personal accident", "Legal expenses"],
  "Consultant - environmental impact": ["Personal accident", "Legal expenses"],
  "Consultant - export": ["Legal expenses", "Personal accident"],
  "Consultant - financial": ["Legal expenses", "Excess sum insured"],
  "Consultant - fire safety": ["Legal expenses", "Excess sum insured"],
  "Consultant - fisheries": ["Legal expenses", "Excess sum insured"],
  "Consultant - food": ["Legal expenses", "Personal accident"],
  "Consultant - food safety & hygiene": ["Legal expenses", "Personal accident"],
  "Consultant - forestry": ["Personal accident", "Legal expenses"],
  "Consultant - hair and beauty": ["Legal expenses", "Personal accident"],
  "Consultant - health and safety": ["Legal expenses", "Personal accident"],
  "Consultant - heating": ["Personal accident", "Excess sum insured"],
  "Consultant - horticulture": ["Legal expenses", "Excess sum insured"],
  "Consultant - hotel and catering": ["Personal accident", "Legal expenses"],
  "Consultant - human resources": ["Legal expenses", "Excess sum insured"],
  "Consultant - image": ["Legal expenses", "Personal accident"],
  "Consultant - immigration": ["Legal expenses", "Excess sum insured"],
  "Consultant - import": ["Legal expenses", "Excess sum insured"],
  "Consultant - industrial": ["Legal expenses", "Excess sum insured"],
  "Consultant - insurance": ["Legal expenses", "Personal accident"],
  "Consultant - investment": ["Legal expenses", "Include contents"],
  "Consultant - legal": ["Legal expenses", "Include contents"],
  "Consultant - lifestyle": ["Legal expenses", "Personal accident"],
  "Consultant - lighting": ["Legal expenses", "Personal accident"],
  "Consultant - management & business": [
    "Legal expenses",
    "Portable equipment",
  ],
  "Consultant - marine": ["Include contents", "Legal expenses"],
  "Consultant - market research": ["Legal expenses", "Excess sum insured"],
  "Consultant - marketing and advertising": [
    "Legal expenses",
    "Include contents",
  ],
  "Consultant - occupational health": ["Legal expenses", "Personal accident"],
  "Consultant - pharmaceutical": ["Legal expenses", "Excess sum insured"],
  "Consultant - planning": ["Legal expenses", "Excess sum insured"],
  "Consultant - political": ["Legal expenses", "Include contents"],
  "Consultant - printing": ["Legal expenses", "Personal accident"],
  "Consultant - procurement": ["Legal expenses", "Excess sum insured"],
  "Consultant - public relations": ["Legal expenses", "Include contents"],
  "Consultant - research": ["Legal expenses", "Include contents"],
  "Consultant - risk management": ["Legal expenses", "Hospital cash plan"],
  "Consultant - science & research": ["Legal expenses", "Personal accident"],
  "Consultant - security": ["Legal expenses", "Excess sum insured"],
  "Consultant - tax": ["Legal expenses", "Excess sum insured"],
  "Consultant - telecommunications": ["Legal expenses", "Personal accident"],
  "Consultant - textiles": ["Legal expenses", "Include contents"],
  "Consultant - thermal & insulation": ["Personal accident", "Legal expenses"],
  "Consultant - traffic": ["Personal accident", "Legal expenses"],
  "Consultant - training": ["Legal expenses", "Include contents"],
  "Consultant - transport": ["Legal expenses", "Personal accident"],
  "Consultant - travel": ["Legal expenses", "Excess sum insured"],
  "Consultant - waste (incl broking)": ["Legal expenses", "Excess sum insured"],
  "Consultant - window": ["Excess sum insured", "Legal expenses"],
  "Contractors combined": ["Legal expenses", "Personal accident"],
  "Cookery Shop": ["Legal expenses", "Include contents"],
  "Cookery Shop in Shops & retail": ["Include contents"],
  "Cooking & ironing services - domestic only": [
    "Excess sum insured",
    "Legal expenses",
  ],
  "Cooking Ingredients": ["Include contents", "Include stock online"],
  Copywriter: ["Legal expenses", "Include contents"],
  "Corner Shop": ["Include stock online", "Include contents"],
  "Corner Shop / Off Licence": ["Include stock online", "Include contents"],
  "Cosmetics Shop": ["Include stock online", "Legal expenses"],
  Counsellor: ["Legal expenses", "Include contents"],
  Courier: ["Legal expenses", "Excess sum insured"],
  "Craft stall": ["Include stock online", "Legal expenses"],
  "Cultural interest group": ["Personal accident", "Excess sum insured"],
  "Curtain & blind maker in Shops & retail": ["Excess sum insured"],
  "Curtain And Blind Manufacturers": ["Include stock online", "Legal expenses"],
  "Curtain,blind makers & fitters": ["Legal expenses", "Excess sum insured"],
  "Curtains & Blinds Shop": ["Include stock online", "Include contents"],
  "Cutlery Shop": ["Include contents", "Excess sum insured"],
  "Cycle Shop": ["Include stock online", "Include contents"],
  "Cycles in Shops & retail": ["Excess sum insured"],
  "DIY Wholesalers": ["Include buildings"],
  "Dance instructor": ["Legal expenses", "Personal accident"],
  Dancer: ["Personal accident", "Excess sum insured"],
  "Data Processor": ["Legal expenses", "Portable equipment"],
  "Data analyst": ["Legal expenses", "Excess sum insured"],
  "Data engineer": ["Excess sum insured", "Portable equipment"],
  "Database Migration": ["Include contents", "Excess sum insured"],
  "Decorators Supplies": ["Personal accident", "Legal expenses"],
  Delicatessen: ["Include contents", "Include stock online"],
  "Delicatessen / Sandwich Bar": ["Include contents", "Include stock online"],
  "Delicatessen in Shops & retail": ["Excess sum insured"],
  "Delivery driver": ["Excess sum insured", "Personal accident"],
  "Dental technician": ["Legal expenses", "Personal accident"],
  Dentist: ["Legal expenses", "Personal accident"],
  "Dentist in Surgery": ["Excess sum insured", "Include contents"],
  "Department Store": ["Business interruption", "Personal accident"],
  "Desk Top Publisher": ["Legal expenses", "Personal accident"],
  "Detached house": ["Include contents", "Legal expenses"],
  Dietician: ["Include contents", "Legal expenses"],
  "Disc jockey": ["Include contents", "Excess sum insured"],
  "Discount Shop": ["Include stock online", "Legal expenses"],
  "Dispensing Chemist": ["Include contents", "Include stock online"],
  "Dispensing Chemist in Shops & retail": ["Excess sum insured"],
  Distillers: ["Include stock online", "Legal expenses"],
  "Diy Shop": ["Include stock online", "Include contents"],
  "Diy Shop - Excluding Timber": [
    "Include stock online",
    "Business interruption",
  ],
  "Diy Shop - Including Timber": ["Include stock online", "Include contents"],
  "Doctor (medical)": ["Legal expenses", "Personal accident"],
  "Dog Beautician": ["Include contents", "Personal accident"],
  "Dog walkers": ["Personal accident", "Legal expenses"],
  "Dolls House Shop": ["Include contents", "Legal expenses"],
  "Dolls Shop": ["Include stock online"],
  "Domestic Appliance Maintenance": ["Legal expenses"],
  "Domestic Appliance Shop": ["Include stock online", "Legal expenses"],
  "Domestic appliance repairers": ["Legal expenses", "Personal accident"],
  "Domestic services-ironing & cooking": ["Legal expenses", "Include contents"],
  "Door to door - franchise": ["Legal expenses", "Excess sum insured"],
  "Double Glazing & Window Retailer": ["Legal expenses", "Personal accident"],
  "Drain cleaners": ["Personal accident", "Legal expenses"],
  "Drapery, haberdashery, soft furnishings in Shops & retail": [
    "Excess sum insured",
  ],
  Draughtsman: ["Legal expenses", "Excess sum insured"],
  "Dress Agency": ["Legal expenses", "Personal accident"],
  "Dress Blouse And Skirt Manufacturers": ["Include buildings"],
  "Dress maker": ["Include stock online", "Legal expenses"],
  Drilling: ["Personal accident", "Legal expenses"],
  "Drive, path & patio laying": ["Personal accident", "Excess sum insured"],
  "Driver - heavy goods vehicle": ["Personal accident", "Legal expenses"],
  "Driver - private car": ["Personal accident", "Legal expenses"],
  "Driver - van & minibus": ["Excess sum insured", "Personal accident"],
  "Driving instructor - cars and goods vehicles under 7.5 tonne": [
    "Personal accident",
    "Legal expenses",
  ],
  "Driving instructor - other vehicles": [
    "Legal expenses",
    "Personal accident",
  ],
  "Dry Cleaners": ["Include contents", "Include stock online"],
  "Dry lining": ["Personal accident", "Legal expenses"],
  "Dry stone walling": ["Legal expenses", "Excess sum insured"],
  "Ductwork installers": ["Personal accident", "Include tools"],
  "Dvd Rental Shop": ["Include contents", "Include stock online"],
  "E-commerce": ["Include stock online", "Business interruption"],
  "Education consultant": ["Legal expenses", "Personal accident"],
  "Educational establishments - excl local authority": [
    "Legal expenses",
    "Include contents",
  ],
  "Electric Motor Wholesalers": ["Include stock online"],
  "Electric Motor, Dynamo and Generator Wholesalers": [
    "Legal expenses",
    "Include stock online",
  ],
  "Electrical Appliance Manufacturing": ["Include stock online"],
  "Electrical Goods Commercial Wholesaling": ["Include stock online"],
  "Electrical Goods Domestic Wholesaling": ["Include stock online"],
  "Electrical Goods Shop": ["Include stock online", "Include contents"],
  "Electrical Repair Shop": ["Include contents", "Include stock online"],
  "Electrical Supplies Manufacturing": ["Include buildings"],
  "Electrical goods manufacture in Industrial units": ["Include contents"],
  Electrician: ["Legal expenses", "Personal accident"],
  "Electrician - portable appliance testing": [
    "Include tools",
    "Excess sum insured",
  ],
  "Electrician in Industrial units": ["Excess sum insured", "Include contents"],
  "Electricians - commercial": ["Legal expenses", "Excess sum insured"],
  "Electricians - domestic": ["Personal accident", "Include tools"],
  "Electronic Office Machinery Wholesaling": [
    "Legal expenses",
    "Personal accident",
  ],
  "Electronic Systems Manufacturers": ["Include stock online"],
  Embroiderer: ["Include contents", "Include stock online"],
  "Employment agency": ["Legal expenses", "Excess sum insured"],
  "Energy assessment - commercial": ["Legal expenses", "Include contents"],
  "Energy assessment - domestic": ["Legal expenses", "Personal accident"],
  "Energy performance certificates / testing": [
    "Legal expenses",
    "Include contents",
  ],
  "Engineer - acoustic": ["Excess sum insured", "Personal accident"],
  "Engineers - building services": ["Personal accident", "Legal expenses"],
  "Engineers - civil": ["Personal accident", "Legal expenses"],
  "Engineers - electrical": ["Personal accident", "Legal expenses"],
  "Engineers - heating, ventilation & air-conditioning design": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Engineers - lighting": ["Excess sum insured", "Personal accident"],
  "Engineers - manufacturing (precision)": [
    "Personal accident",
    "Legal expenses",
  ],
  "Engineers - mechanical & electrical building services": [
    "Legal expenses",
    "Personal accident",
  ],
  "Engineers - mechanical (process control & production line)": [
    "Personal accident",
    "Legal expenses",
  ],
  "Engineers - project coordination (excluding appointment of subcontractors)":
    ["Legal expenses", "Excess sum insured"],
  "Engineers - project management": ["Legal expenses", "Personal accident"],
  "Engineers - refrigeration": ["Legal expenses", "Excess sum insured"],
  "Engineers - structural": ["Legal expenses", "Excess sum insured"],
  Engraver: ["Legal expenses", "Personal accident"],
  "Engraving / Shoe Repairing": ["Include contents", "Personal accident"],
  "Engraving Shop": ["Include contents", "Include stock online"],
  "Entertainment Supplies": ["Include contents", "Legal expenses"],
  "Entire building with multiple flats - converted building or house": [
    "Include contents",
    "Excess sum insured",
  ],
  "Entire building with multiple flats - purpose built": [
    "Include contents",
    "Excess sum insured",
  ],
  "Environmental health officers": ["Legal expenses", "Personal accident"],
  "Estate Agents in Shops & retail": ["Excess sum insured", "Include contents"],
  "Estate agent - commercial": ["Legal expenses", "Excess sum insured"],
  "Estate agent - domestic": ["Legal expenses", "Excess sum insured"],
  "Event decorator": ["Include stock online", "Legal expenses"],
  "Event organiser": ["Legal expenses", "Personal accident"],
  "Exhibition designer": ["Legal expenses", "Personal accident"],
  "Exhibition stand erector": ["Personal accident", "Include tools"],
  "Fabric Manufacturing": ["Include stock online"],
  "Fabric Shop": ["Include stock online", "Include contents"],
  Fabrications: ["Include stock online", "Legal expenses"],
  "Fabrics, Cloth & Goods in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Face painting": ["Legal expenses", "Include tools"],
  "Facilities management": ["Legal expenses", "Personal accident"],
  "Fancy Dress Shop": ["Legal expenses", "Include stock online"],
  "Farm Shop": ["Legal expenses", "Include stock online"],
  "Fascia / guttering installation": [
    "Personal accident",
    "Excess sum insured",
  ],
  "Fashion Accessories": ["Include stock online", "Legal expenses"],
  "Fashion Accessories Shop": ["Include stock online", "Business interruption"],
  "Fashion Boutique": ["Include stock online", "Include contents"],
  "Fashion Shop": ["Include stock online", "Include contents"],
  "Fashion design": ["Include contents", "Include stock online"],
  "Fast Food": ["Include contents", "Include stock online"],
  "Fast Food / Take Away Food": ["Include contents", "Include stock online"],
  "Fast Food Shop": ["Include contents", "Include stock online"],
  "Fast food delivery": ["Legal expenses", "Excess sum insured"],
  "Fast food in Food & drink": ["Excess sum insured"],
  "Father Christmas": ["Personal accident"],
  "Fencing Manufacturing": ["Include buildings"],
  "Fencing contractors": ["Personal accident", "Legal expenses"],
  "Financial advisor / ifa": ["Legal expenses", "Include contents"],
  "Fire proofing engineer": ["Personal accident", "Legal expenses"],
  "Fireplace Shop": ["Include stock online", "Include contents"],
  "Fireplace Surround Manufacturing Stone": ["Include stock online"],
  "Fireplace installation": ["Personal accident", "Excess sum insured"],
  "First aid training": ["Legal expenses", "Include contents"],
  "Fish & Chip Shop": ["Include contents", "Business interruption"],
  "Fish & Chip Shop / Take Away Food": [
    "Include contents",
    "Include stock online",
  ],
  "Fishing Equipment (Ex Clothing) Manufacturers": [
    "Personal accident",
    "Include stock online",
  ],
  "Fishing Tackle Shop": ["Include stock online", "Include contents"],
  Fishmonger: ["Personal accident", "Include stock online"],
  "Fitness instructor": ["Legal expenses", "Personal accident"],
  "Fitted furniture installers excluding manufacturing": [
    "Excess sum insured",
    "Personal accident",
  ],
  "Fitted furniture installers including manufacturing": [
    "Legal expenses",
    "Personal accident",
  ],
  "Flooring Shop": ["Include contents", "Include stock online"],
  "Flooring Shop in Shops & retail": ["Include contents"],
  "Flooring contractors - commercial": ["Personal accident", "Legal expenses"],
  "Flooring contractors - domestic": ["Personal accident", "Legal expenses"],
  Florist: ["Include stock online", "Personal accident"],
  "Florist in Warehousing": ["Include contents"],
  "Florists / Gift Shop": ["Include stock online", "Include contents"],
  "Flower Arranging": ["Include contents", "Include stock online"],
  "Flower arranger": ["Include stock online", "Personal accident"],
  "Food Shop": ["Include contents", "Include stock online"],
  "Food stall": ["Legal expenses", "Excess sum insured"],
  "Footwear Shop": ["Include contents", "Include stock online"],
  "Fortune teller": ["Personal accident", "Hospital cash plan"],
  "French polisher": ["Personal accident", "Legal expenses"],
  "Frozen Food Shop": ["Personal accident", "Include contents"],
  "Frozen Foods Manufacturers": ["Personal accident", "Include stock online"],
  "Frozen Foods Wholesalers": ["Include stock online", "Personal accident"],
  "Fruit & Vegetable Product Wholesaling": [
    "Include stock online",
    "Include buildings",
  ],
  "Fruit And Vegetable Wholesalers": ["Include stock online", "Legal expenses"],
  "Fruit Shop": ["Include contents", "Legal expenses"],
  "Funeral Director": ["Legal expenses", "Include contents"],
  Furnisher: ["Legal expenses", "Excess sum insured"],
  "Furniture (Metal) Wholesalers": ["Legal expenses", "Include buildings"],
  "Furniture Accessories Shop": ["Legal expenses", "Include stock online"],
  "Furniture Manufacturing Wood, Bamboo or Cane": [
    "Include stock online",
    "Legal expenses",
  ],
  "Furniture Repair Shop": ["Include contents"],
  "Furniture Shop": ["Include stock online", "Include contents"],
  "Furniture in Shops & retail": ["Excess sum insured", "Include contents"],
  "Furniture removal": ["Excess sum insured", "Legal expenses"],
  "GP in Surgery": ["Excess sum insured", "Include contents"],
  "Gadget Shop": ["Legal expenses"],
  Gallery: ["Include contents", "Include stock online"],
  "Games Shop": ["Include stock online", "Include contents"],
  "Garage & shed erectors": ["Personal accident", "Include tools"],
  "Garage door and gate fitters": ["Personal accident", "Legal expenses"],
  "Garden Centre": ["Business interruption", "Include contents"],
  "Garden Equipment": ["Legal expenses", "Include contents"],
  "Garden Equipment in Shops & retail": ["Excess sum insured"],
  "Garden Shop": ["Include stock online", "Legal expenses"],
  "Garden designer": ["Legal expenses", "Personal accident"],
  "Garden machinery sale, maintenance & repair": [
    "Legal expenses",
    "Personal accident",
  ],
  "Garden maint ex tree felling": ["Personal accident", "Include tools"],
  "Garden maint inc treefelling": ["Include tools", "Personal accident"],
  "Gardening Nursery": ["Personal accident", "Include stock online"],
  "Gardening Nursery in Shops & retail": ["Excess sum insured"],
  "Gas fitters": ["Personal accident", "Excess sum insured"],
  "General Goods Store": ["Include stock online", "Include contents"],
  "General Store": ["Include contents", "Include stock online"],
  "General Store / Off Licence": ["Include stock online", "Include contents"],
  "Gift Shop": ["Include stock online", "Include contents"],
  "Gift Shop / Tea Room": ["Include contents", "Include stock online"],
  "Gift Shop / Tea Room in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Glass Merchant": ["Legal expenses", "Include stock online"],
  "Glass Products in Shops & retail": ["Excess sum insured"],
  "Glass Works": ["Include buildings"],
  Glaziers: ["Personal accident", "Legal expenses"],
  "Glaziers inc double glazing": ["Personal accident", "Legal expenses"],
  "Golf Equipment Shop": ["Include contents", "Excess sum insured"],
  "Golf Professionals": ["Include contents", "Legal expenses"],
  "Golf Shop": ["Include contents", "Personal accident"],
  "Gourmet Food Shop": ["Include stock online"],
  "Graphic designers": ["Include contents", "Legal expenses"],
  Greengrocer: ["Include stock online", "Include contents"],
  "Greengrocer in Shops & retail": ["Include contents", "Excess sum insured"],
  "Greeting Cards": ["Include stock online", "Include contents"],
  Grocer: ["Include stock online", "Include contents"],
  "Grocer in Shops & retail": ["Include contents", "Excess sum insured"],
  "Grocery Wholesalers": ["Include stock online", "Legal expenses"],
  Groundwork: ["Personal accident", "Legal expenses"],
  "Guest House - Unlicensed": ["Personal accident", "Include contents"],
  "Gutter & fascia cleaning": ["Personal accident", "Legal expenses"],
  "Guttering, fascia installation": ["Personal accident", "Legal expenses"],
  Gymnasia: ["Include contents", "Legal expenses"],
  Haberdashery: ["Include stock online", "Include contents"],
  "Hair extension technician": ["Legal expenses", "Excess sum insured"],
  Hairdresser: ["Personal accident", "Include tools"],
  Hairdressers: ["Include contents", "Include stock online"],
  "Hairdressing & beauty salon in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Hairdressing Salon": ["Include contents", "Include stock online"],
  "Hairpiece & Wig Shop": ["Include contents", "Business interruption"],
  "Halls and public venues - excl sports stadia": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Handmade crafts": ["Include stock online", "Legal expenses"],
  "Handyman (property maintenance only)": [
    "Personal accident",
    "Legal expenses",
  ],
  "Hardware Tools Shop": ["Include contents", "Include stock online"],
  "Hat Hire Shop": ["Include stock online", "Include contents"],
  Haulier: ["Excess sum insured", "Personal accident"],
  "Health & Beauty Shop": ["Include contents", "Include stock online"],
  "Health Food Shop": ["Include stock online", "Include contents"],
  "Health Food Shop in Shops & retail": [
    "Excess sum insured",
    "Include contents",
  ],
  "Healthcare assistant": ["Personal accident", "Legal expenses"],
  "Heavy Machinery Manufacturing": ["Legal expenses", "Include stock online"],
  "Herbs & Spices Shop": ["Legal expenses", "Include stock online"],
  "Hobby Shop": ["Include stock online", "Include contents"],
  "Home baking": ["Legal expenses", "Excess sum insured"],
  "Home help": ["Personal accident", "Legal expenses"],
  Homeopath: ["Legal expenses", "Personal accident"],
  Homewares: ["Include stock online", "Include contents"],
  "Horse Supply Shop": ["Legal expenses", "Personal accident"],
  "Horticultural Goods Shop": ["Include contents", "Include stock online"],
  "Hospitality worker": ["Legal expenses", "Personal accident"],
  "House sitters": ["Personal accident", "Legal expenses"],
  "Household Shop": ["Include contents", "Include stock online"],
  "Hygiene and cleansing services - exc industrial cleaning": [
    "Excess sum insured",
    "Legal expenses",
  ],
  "IT Consultant": ["Legal expenses", "Excess sum insured"],
  "IT Contractor": ["Legal expenses", "Excess sum insured"],
  "IT Hardware Design": ["Portable equipment", "Include contents"],
  "IT Hardware Leasing": ["Legal expenses", "Excess sum insured"],
  "IT Hardware Maintenance & Repair": ["Personal accident"],
  "IT Hardware Manufacture &/or Assembly": [
    "Include contents",
    "Portable equipment",
  ],
  "IT Hardware Sales & Supply - New": [
    "Include contents",
    "Portable equipment",
  ],
  "IT Hardware Sales & Supply - Second Hand": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "IT Outsourcing - Consultancy": ["Legal expenses", "Excess sum insured"],
  "IT Outsourcing - Data Backup & Storage": [
    "Legal expenses",
    "Personal accident",
  ],
  "IT Outsourcing - Database Management": ["Legal expenses"],
  "IT Outsourcing - IT Facilities Management": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "IT Programme Management": ["Legal expenses", "Excess sum insured"],
  "IT Security - Consultancy": ["Legal expenses", "Excess sum insured"],
  "IT Security - Penetration Testing": ["Legal expenses", "Excess sum insured"],
  "IT Training": ["Legal expenses", "Portable equipment"],
  "Ice Cream Parlour": ["Include contents", "Include stock online"],
  "Ice Cream Wholesalers": ["Include stock online"],
  "Ice cream van": ["Include stock online", "Legal expenses"],
  Illustrator: ["Include contents", "Legal expenses"],
  "Individual flat - in converted building or house": [
    "Include contents",
    "Legal expenses",
  ],
  "Individual flat - in purpose built block or building": [
    "Include contents",
    "Legal expenses",
  ],
  "Industrial machinery manufacture in Industrial units": ["Include contents"],
  "Injection Moulding Wholesaling Plastic": ["Include stock online"],
  "Insulation contractor": ["Personal accident", "Excess sum insured"],
  "Insurance agent / broker": ["Legal expenses", "Include contents"],
  "Insurance assessor": ["Legal expenses", "Excess sum insured"],
  "Insurance claims management": ["Personal accident", "Excess sum insured"],
  "Insurance motor vehicle inspector": ["Personal accident", "Legal expenses"],
  "Interim management": ["Legal expenses", "Portable equipment"],
  "Interior Design Shop": ["Include contents", "Include stock online"],
  "Interior Fitting Shop": ["Legal expenses", "Personal accident"],
  "Interior designer": ["Legal expenses", "Excess sum insured"],
  "Interiors Shop": ["Include stock online", "Include contents"],
  "Internet Café": ["Include contents", "Legal expenses"],
  "Internet Service Provider": ["Legal expenses", "Excess sum insured"],
  "Internet Trader": ["Include stock online", "Legal expenses"],
  Interpreter: ["Legal expenses", "Excess sum insured"],
  "Inventory clerk": ["Legal expenses", "Personal accident"],
  "Ironing & cooking services - domestic only": [
    "Legal expenses",
    "Include tools",
  ],
  Ironmonger: ["Include contents", "Include stock online"],
  "Ironmongery & hardware in Shops & retail": ["Include contents"],
  "Jet washing": ["Personal accident", "Excess sum insured"],
  Jeweller: ["Include stock online", "Include contents"],
  Jewellers: ["Legal expenses", "Include contents"],
  "Jewellers design": ["Include stock online", "Legal expenses"],
  "Jewellery - Wholesale": ["Include stock online", "Business interruption"],
  "Jewellery Repair Shop": ["Include stock online", "Personal accident"],
  "Jewellery in Shops & retail": ["Include contents"],
  Joiners: ["Personal accident", "Include tools"],
  "Joinery Manufacturers": ["Legal expenses", "Personal accident"],
  Journalists: ["Include contents", "Personal accident"],
  "Juice Bar": ["Include contents", "Legal expenses"],
  "Key Cutters / Shoe Repairing": ["Include contents", "Personal accident"],
  "Kitchen / Bathroom Showroom": ["Include contents", "Legal expenses"],
  "Kitchen fitter": ["Legal expenses", "Personal accident"],
  "Knitted garment maker": ["Include contents", "Legal expenses"],
  "Knitwear Shop": ["Include stock online", "Excess sum insured"],
  Labourer: ["Personal accident", "Legal expenses"],
  "Lamp Shop": ["Include stock online", "Include contents"],
  "Landscape gard excluding treefelling": [
    "Personal accident",
    "Legal expenses",
  ],
  "Landscape gard including treefelling": [
    "Personal accident",
    "Legal expenses",
  ],
  "Launderette - Attended": ["Include contents", "Include stock online"],
  "Laundrette (attended) in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  Lawyer: ["Include contents", "Legal expenses"],
  "Licenced Premises": ["Include contents", "Business interruption"],
  "Licensed Café": ["Include contents", "Include stock online"],
  "Licensed grocer in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  "Licensed premises in Food & drink": ["Excess sum insured"],
  "Life coach": ["Legal expenses", "Include contents"],
  "Lift engineer (incl certification)": ["Legal expenses", "Personal accident"],
  "Lift installation": ["Personal accident", "Excess sum insured"],
  "Lift maintenance": ["Personal accident", "Legal expenses"],
  "Light metal fabrication": ["Legal expenses", "Personal accident"],
  "Lighting Goods Manufacturing": ["Legal expenses"],
  "Lighting Shop": ["Include contents", "Include stock online"],
  "Linen Hire Shop": ["Personal accident", "Include contents"],
  "Lingerie Shop": ["Legal expenses", "Business interruption"],
  "Lock/Key Wholesalers": ["Personal accident", "Include buildings"],
  Locksmith: ["Include tools", "Legal expenses"],
  "Locum - general practitioner": ["Excess sum insured", "Include contents"],
  "Loss adjuster": ["Personal accident", "Excess sum insured"],
  "Loss assessor": ["Legal expenses", "Excess sum insured"],
  "Luggage & Handbag Shop": ["Excess sum insured", "Legal expenses"],
  "Machinery commissioning, repair and service": [
    "Legal expenses",
    "Personal accident",
  ],
  "Machinery installation & removal (work away) excl heat": [
    "Personal accident",
    "Legal expenses",
  ],
  Maisonette: ["Legal expenses", "Include contents"],
  "Make-up artist": ["Include tools", "Include stock online"],
  "Management consultant": ["Legal expenses", "Excess sum insured"],
  "Manicurist & pedicurist": ["Include tools", "Personal accident"],
  "Marble, Stone And Granite Wholesalers": ["Legal expenses"],
  "Marine Shop": ["Personal accident", "Illness and injury protection"],
  "Market researcher": ["Legal expenses", "Include contents"],
  "Market trader": ["Include stock online", "Legal expenses"],
  "Marketing agency": ["Legal expenses", "Include contents"],
  "Marketing consultant": ["Legal expenses", "Include contents"],
  "Marketing-direct": ["Legal expenses", "Include contents"],
  "Marquee hirer": ["Include stock online", "Legal expenses"],
  "Masonry & stone cleaning": ["Personal accident", "Legal expenses"],
  Massage: ["Legal expenses", "Personal accident"],
  "Mattress Shop": ["Include stock online"],
  "Meat, Fish & Poultry Shop": ["Include stock online", "Personal accident"],
  "Media Shop": ["Legal expenses", "Excess sum insured"],
  "Medical Equipment Manufacturers": ["Include stock online"],
  "Medical Equipment Wholesaling": ["Include stock online", "Legal expenses"],
  "Metal polishing": ["Legal expenses", "Hospital cash plan"],
  "Metalworker - Fabrication": ["Personal accident", "Include stock online"],
  "Metalworker - heavy metal goods manufacture": [
    "Personal accident",
    "Legal expenses",
  ],
  "Metalworker - high tech products": ["Hospital cash plan", "Legal expenses"],
  "Metalworker - light metal goods (incl gates and railings)": [
    "Personal accident",
    "Legal expenses",
  ],
  Milkman: ["Legal expenses", "Personal accident"],
  Millinery: ["Legal expenses", "Include stock online"],
  "Mobile Phone Shop": ["Include stock online", "Include contents"],
  "Mobile Phone Shop in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  "Mobile barber (including renting a chair)": [
    "Legal expenses",
    "Include tools",
  ],
  "Mobile beautician (including renting a chair)": [
    "Legal expenses",
    "Include tools",
  ],
  "Mobile food van": ["Excess sum insured", "Personal accident"],
  "Mobile hairdresser (including renting a chair)": [
    "Include tools",
    "Personal accident",
  ],
  "Mobility Shop": ["Legal expenses", "Include stock online"],
  "Model Shop": ["Include contents", "Include stock online"],
  "Model maker": ["Personal accident", "Legal expenses"],
  "Models, model agencies": ["Legal expenses", "Include contents"],
  "Money Exchange": ["Hospital cash plan", "Include contents"],
  "Monumental mason & sculptures": ["Include contents", "Excess sum insured"],
  "Mortgage adviser / broker": ["Legal expenses", "Include contents"],
  "Motor trade & garage in Shops & retail": [
    "Include contents",
    "Excess sum insured",
  ],
  "Motorbike Accessories": ["Include stock online", "Include contents"],
  "Music Shop": ["Include contents", "Include stock online"],
  "Music teacher / publisher": ["Legal expenses", "Include contents"],
  "Musical Instrument Shop": ["Include stock online"],
  "Musician - group - classical, folk & group": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Musician - group - other": ["Include contents", "Legal expenses"],
  "Musician - individual - classical, folk or jazz": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Musician - individual - other": ["Include contents", "Legal expenses"],
  "Mustard Spice And Pepper Wholesalers": ["Include stock online"],
  "Nail Bar": ["Include contents", "Legal expenses"],
  "Nail Bar in Shops & retail": ["Excess sum insured", "Include contents"],
  Nanny: ["Personal accident", "Legal expenses"],
  "Network & Systems Support": ["Legal expenses", "Excess sum insured"],
  "News Stand": ["Include stock online"],
  Newsagents: ["Include stock online", "Include contents"],
  "Newsagents / Off Licence": ["Include stock online", "Include contents"],
  "Newsagents / Post Office": ["Include stock online", "Include contents"],
  "Newsagents in Shops & retail": ["Excess sum insured", "Include contents"],
  "Non-dispensing Chemist": ["Legal expenses", "Include contents"],
  Nurse: ["Legal expenses", "Personal accident"],
  "Nursery schools and playgroups": ["Legal expenses", "Personal accident"],
  Nutritionist: ["Legal expenses", "Excess sum insured"],
  "Nvq assessor": ["Legal expenses", "Personal accident"],
  "Occupational therapist": ["Legal expenses", "Excess sum insured"],
  "Off Licence": ["Include stock online", "Include contents"],
  "Off-licence in Shops & retail": ["Excess sum insured", "Include contents"],
  "Office Equipment Supplier (Including Electrical)": [
    "Legal expenses",
    "Include stock online",
  ],
  "Office Furniture Shop": ["Include stock online", "Personal accident"],
  "Office Services Shop": ["Legal expenses"],
  "Office Supplies Shop": ["Include contents", "Personal accident"],
  "Office cleaner": ["Personal accident", "Legal expenses"],
  "Office equipment repair": ["Personal accident"],
  "Offices & clerical services in Offices": [
    "Include contents",
    "Excess sum insured",
  ],
  "Ofsted inspector": ["Legal expenses"],
  "Online Retailer": ["Include stock online", "Legal expenses"],
  "Online Shop": ["Include stock online", "Legal expenses"],
  "Online Store": ["Legal expenses", "Include stock online"],
  Optician: ["Include contents", "Include stock online"],
  "Opticians in Shops & retail": ["Include contents", "Excess sum insured"],
  Optometrist: ["Legal expenses", "Include contents"],
  "Organic Food Shop": ["Include contents", "Legal expenses"],
  Other: ["Include contents", "Excess sum insured"],
  "Paint & Wallpaper Shop": ["Excess sum insured", "Include stock online"],
  "Paint sprayers": ["Personal accident", "Legal expenses"],
  "Painter & decorator": ["Personal accident", "Legal expenses"],
  "Painter (artistic, sculptors or potters)": [
    "Personal accident",
    "Legal expenses",
  ],
  "Partition contractor": ["Include tools", "Excess sum insured"],
  "Party planner": ["Legal expenses", "Personal accident"],
  "Path, patio & drive laying": ["Personal accident", "Excess sum insured"],
  Pathologist: ["Excess sum insured", "Legal expenses"],
  "Pedicurist & manicurist": ["Legal expenses", "Personal accident"],
  "Pen Shop": ["Legal expenses"],
  "Perfume Shop": ["Include stock online", "Legal expenses"],
  "Personal / sports trainer": ["Personal accident", "Legal expenses"],
  "Personal Training Shop": ["Include contents", "Legal expenses"],
  "Personal assistant": ["Personal accident", "Legal expenses"],
  "Pest & vermin control services": ["Personal accident", "Legal expenses"],
  "Pet Accessory Shop": ["Include stock online", "Include contents"],
  "Pet Beautician in Shops & retail": ["Include contents"],
  "Pet Parlour": ["Include stock online", "Personal accident"],
  "Pet Shop": ["Include stock online", "Include contents"],
  "Pet Shop in Shops & retail": ["Excess sum insured"],
  "Pet grooming": ["Personal accident", "Legal expenses"],
  "Pet minder": ["Personal accident", "Legal expenses"],
  "Pharmaceutical Supplier": ["Personal accident", "Legal expenses"],
  Pharmacy: ["Include contents", "Personal accident"],
  "Pharmacy in Shops & retail": ["Include contents", "Excess sum insured"],
  "Photo Processing & Printing Shop": [
    "Include contents",
    "Include stock online",
  ],
  Photobooth: ["Include contents", "Portable equipment"],
  Photographer: ["Include contents", "Portable equipment"],
  "Photographic Studio": ["Include contents", "Legal expenses"],
  Physiologist: ["Legal expenses", "Personal accident"],
  Physiotherapist: ["Legal expenses", "Personal accident"],
  "Piano tuner": ["Include tools", "Personal accident"],
  "Pickled Food Wholesalers": ["Personal accident", "Include stock online"],
  "Picture Framing": ["Include stock online", "Include contents"],
  "Picture Shop": ["Include stock online"],
  "Picture framer": ["Legal expenses", "Include stock online"],
  "Pipe & Tube Manufacturing Plastic": ["Include stock online"],
  "Pipework contractors - commercial": [
    "Personal accident",
    "Excess sum insured",
  ],
  "Plant hire - commercial": ["Legal expenses", "Excess sum insured"],
  "Plant hire - diy": ["Include contents", "Legal expenses"],
  "Plant user - construction plant exc cranes": [
    "Personal accident",
    "Legal expenses",
  ],
  Plasterer: ["Personal accident", "Legal expenses"],
  "Playgroups and nursery schools": ["Legal expenses", "Personal accident"],
  "Plumbers Merchant": ["Personal accident", "Include contents"],
  "Plumbing, heating and ventilation contractor": [
    "Legal expenses",
    "Personal accident",
  ],
  "Pneumatic Equipment Manufacturers": ["Legal expenses"],
  "Portable appliance testing": ["Excess sum insured", "Legal expenses"],
  "Post Office": ["Include stock online", "Include contents"],
  "Post Office Services": ["Include stock online", "Include contents"],
  "Pottery Goods Manufacturers": ["Include stock online"],
  "Pottery Shop": ["Include stock online", "Include contents"],
  Preacher: ["Legal expenses", "Excess sum insured"],
  "Precision Engineers": ["Legal expenses", "Include stock online"],
  "Precision engineer in Industrial units": ["Include contents"],
  "Pressure washing": ["Excess sum insured", "Personal accident"],
  "Principal contractor": ["Legal expenses", "Excess sum insured"],
  "Principal designer": ["Legal expenses", "Excess sum insured"],
  "Print Shop": ["Include contents", "Include stock online"],
  Printers: ["Legal expenses", "Include stock online"],
  "Printing - computer based": ["Include stock online", "Include contents"],
  "Printing - other": ["Personal accident", "Legal expenses"],
  "Private investigator": ["Legal expenses", "Excess sum insured"],
  "Probate services": ["Excess sum insured", "Legal expenses"],
  "Product design": ["Legal expenses", "Personal accident"],
  "Project manager": ["Legal expenses", "Personal accident"],
  "Property auditor": ["Legal expenses", "Excess sum insured"],
  "Property maintenance / handyman": ["Excess sum insured", "Legal expenses"],
  "Property managing agent - commercial": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Property managing agent - residential": [
    "Legal expenses",
    "Excess sum insured",
  ],
  "Property searches": ["Legal expenses", "Excess sum insured"],
  Psychiatrist: ["Excess sum insured", "Legal expenses"],
  Psychologist: ["Legal expenses", "Include contents"],
  Psychotherapist: ["Legal expenses", "Include contents"],
  "Public House": ["Include contents", "Include stock online"],
  "Public Houses / Restaurant - Licensed": [
    "Include contents",
    "Include stock online",
  ],
  "Public relations officer": ["Legal expenses", "Personal accident"],
  "Publicity management": ["Legal expenses", "Include contents"],
  Publisher: ["Legal expenses", "Excess sum insured"],
  "Record Shop": ["Include stock online", "Include contents"],
  "Recruitment agency": ["Legal expenses", "Excess sum insured"],
  "Recruitment consultant": ["Legal expenses", "Include contents"],
  Reflexologist: ["Personal accident", "Include stock online"],
  "Refrigeration Engineering": ["Legal expenses"],
  "Refrigeration engineers": ["Personal accident", "Legal expenses"],
  Rendering: ["Legal expenses", "Personal accident"],
  "Residents association": ["Legal expenses"],
  "Residents association (Not For Profit)": ["Legal expenses"],
  "Restaurant - Licensed": ["Include contents", "Include stock online"],
  "Restaurant - Unlicensed": ["Include contents", "Include stock online"],
  "Restaurant - licensed in Food & drink": [
    "Excess sum insured",
    "Include contents",
  ],
  "Restaurant - unlicensed in Food & drink": ["Excess sum insured"],
  "Road marking contractors": ["Legal expenses", "Personal accident"],
  "Roofers excluding the application of heat": [
    "Personal accident",
    "Legal expenses",
  ],
  "Roofers including the application of heat": [
    "Personal accident",
    "Excess sum insured",
  ],
  "Saddlery & Tack Shop": ["Legal expenses", "Include stock online"],
  "Safety Workwear Shop": ["Include contents", "Excess sum insured"],
  "Sales representative": ["Personal accident", "Legal expenses"],
  "Sandwich Bar": ["Include contents", "Business interruption"],
  "Sandwich Bar / Take Away Food": ["Include contents", "Include stock online"],
  "Sandwich bar in Food & drink": ["Excess sum insured"],
  "Santa Claus": ["Personal accident", "Excess sum insured"],
  "Satellite dish installer": ["Personal accident", "Excess sum insured"],
  "Sauce And Pickle Manufacturing": ["Legal expenses"],
  Scaffolding: ["Excess sum insured", "Personal accident"],
  "School Uniform Shop": ["Include contents", "Include stock online"],
  "Schools and colleges": ["Personal accident", "Legal expenses"],
  "Screen / script writer": ["Include contents", "Legal expenses"],
  "Sculpture Shop": ["Include contents", "Include stock online"],
  "Seasonal Dress Shop": ["Include stock online", "Include contents"],
  "Second Hand Furniture Shop": ["Include stock online", "Include contents"],
  "Secretarial / clerical services": ["Legal expenses", "Include contents"],
  "Security - training only": ["Legal expenses", "Excess sum insured"],
  "Security Goods Shop": ["Legal expenses", "Personal accident"],
  "Security Systems Shop": ["Include contents", "Legal expenses"],
  "Security guard": ["Legal expenses", "Excess sum insured"],
  "Semi-detached house": ["Legal expenses", "Include contents"],
  "Server Hosting": ["Legal expenses", "Include contents"],
  "Sewing Machine Shop": ["Include contents", "Include stock online"],
  "Sewing Supplies": ["Include contents", "Business interruption"],
  "Sewing/Textile Machine Manufacturers": ["Include stock online"],
  "Sharpening Services": ["Include stock online"],
  "Shed & carport erector": ["Excess sum insured", "Legal expenses"],
  "Shoe Repair Shop": ["Include stock online", "Include contents"],
  "Shoe Shop": ["Include contents", "Include stock online"],
  "Shoe polisher": ["Personal accident"],
  "Shoe repairer": ["Include stock online", "Include contents"],
  "Shop fitters": ["Personal accident", "Excess sum insured"],
  Shuttering: ["Legal expenses", "Excess sum insured"],
  "Sign Making - Plastic": ["Legal expenses", "Include stock online"],
  "Sign Manufacturing Metal Illuminated": [
    "Personal accident",
    "Include buildings",
  ],
  "Sign erectors": ["Personal accident", "Legal expenses"],
  "Sign writer in Shops & retail": ["Excess sum insured"],
  Signwriter: ["Personal accident", "Legal expenses"],
  Singer: ["Include contents", "Personal accident"],
  "Site clearance": ["Excess sum insured", "Personal accident"],
  "Skip hire": ["Legal expenses", "Include own plant"],
  "Snack Bar": ["Include contents", "Business interruption"],
  "Social worker": ["Legal expenses", "Personal accident"],
  "Soft Drinks Manufacturing": ["Legal expenses", "Include stock online"],
  "Soft Drinks Wholesalers": ["Legal expenses", "Include stock online"],
  "Soft Furnishings Shop": ["Include contents", "Legal expenses"],
  "Software Consultant": ["Legal expenses", "Excess sum insured"],
  "Software Developer": ["Legal expenses", "Excess sum insured"],
  "Software Engineer": ["Legal expenses", "Portable equipment"],
  "Software house & video game production in Offices": ["Excess sum insured"],
  "Solar panel installation": ["Legal expenses", "Personal accident"],
  Solicitor: ["Legal expenses", "Include contents"],
  "Speech therapist": ["Legal expenses", "Include contents"],
  "Sports Equipment (excl. Clothing) in Warehousing": ["Excess sum insured"],
  "Sports Goods Shop": ["Include stock online", "Include contents"],
  "Sports Shop": ["Include stock online", "Include contents"],
  "Sports/personal trainer": ["Legal expenses", "Personal accident"],
  "Sportswear Shop": ["Legal expenses", "Include stock online"],
  "Staircase (Wood) Manufacturers": ["Legal expenses", "Include stock online"],
  "Standalone Tools": ["Include tools"],
  "Stationary Shop": ["Include contents", "Include stock online"],
  Stationer: ["Legal expenses", "Include stock online"],
  "Stationery in Shops & retail": ["Include contents"],
  Statistician: ["Legal expenses", "Include contents"],
  "Steel erection": ["Personal accident", "Excess sum insured"],
  Stockbroker: ["Include contents"],
  Stonemason: ["Personal accident", "Legal expenses"],
  "Storage Plant And Tanks and Process Vessels - Manufacturing": [
    "Legal expenses",
    "Personal accident",
  ],
  "Stove Shop": ["Legal expenses", "Include stock online"],
  "Sunglasses Shop": ["Excess sum insured", "Legal expenses"],
  Supermarket: ["Include stock online", "Include contents"],
  "Supermarket Wholesale": ["Include stock online"],
  "Support worker": ["Personal accident", "Legal expenses"],
  "Surveyor - building society agency": ["Personal accident"],
  "Surveyor - building surveying": ["Legal expenses", "Personal accident"],
  "Surveyor - commercial": ["Legal expenses", "Excess sum insured"],
  "Surveyor - damp proof & control": ["Legal expenses", "Excess sum insured"],
  "Surveyor - expert witness": ["Legal expenses"],
  "Surveyor - land & hydrographic": ["Legal expenses", "Personal accident"],
  "Surveyor - party wall/schedules of dilapidations": [
    "Legal expenses",
    "Personal accident",
  ],
  "Surveyor - planning supervision": ["Legal expenses", "Include tools"],
  "Surveyor - project coordination": ["Excess sum insured", "Legal expenses"],
  "Surveyor - project management": ["Legal expenses", "Personal accident"],
  "Surveyor - quantity surveying": ["Legal expenses", "Excess sum insured"],
  "Surveyor - rating consultancy": ["Legal expenses", "Excess sum insured"],
  "Surveyor - residential": ["Legal expenses", "Personal accident"],
  "Sweet Shop": ["Include stock online", "Include contents"],
  "Sweet Wholesaling": ["Personal accident", "Legal expenses"],
  "Swim Shop": ["Include stock online", "Include contents"],
  "Swimming pool cleaners": ["Legal expenses", "Excess sum insured"],
  "Swimming pool installers": ["Legal expenses", "Excess sum insured"],
  Tailor: ["Include stock online", "Personal accident"],
  "Tailor And Outfitter": ["Include buildings", "Legal expenses"],
  "Take Away Food": ["Include contents", "Include stock online"],
  "Take-away food in Food & drink": ["Excess sum insured", "Include contents"],
  "Tax advisor": ["Legal expenses", "Excess sum insured"],
  "Taxi driver": ["Legal expenses", "Excess sum insured"],
  Taxidermist: ["Include stock online", "Excess sum insured"],
  "Tea & Coffee Shop": ["Include contents", "Include stock online"],
  "Tea Room": ["Include contents", "Include stock online"],
  "Teacher / tutor": ["Legal expenses", "Include contents"],
  "Teaching assistant": ["Excess sum insured", "Personal accident"],
  "Telecommunication Equipment Wholesalers": [
    "Personal accident",
    "Include stock online",
  ],
  "Telecommunications Shop": ["Include contents", "Include stock online"],
  "Telemarketer / telesales": ["Legal expenses", "Personal accident"],
  "Telephone engineers": ["Personal accident", "Legal expenses"],
  "Telephone point/extension installation": ["Legal expenses"],
  "Terraced / End terrace house": ["Legal expenses", "Include contents"],
  "Textile Manufacturing": ["Include buildings", "Include stock online"],
  "Textile Shop": ["Include stock online", "Include contents"],
  "Textile Wholesalers": ["Include stock online"],
  "Theatre and concert lighting": ["Personal accident", "Legal expenses"],
  "Theatre group": ["Excess sum insured"],
  "Ticket / theatre agent": ["Excess sum insured", "Legal expenses"],
  "Tile Shop": ["Legal expenses", "Include contents"],
  "Tile Wholesalers": ["Include stock online"],
  "Tilers - floor & wall": ["Personal accident", "Legal expenses"],
  "Tilers - roofs": ["Personal accident", "Excess sum insured"],
  "Timber preservation": ["Legal expenses", "Personal accident"],
  Tobacconist: ["Include stock online", "Business interruption"],
  "Tool Rental Shop": ["Include contents", "Business interruption"],
  "Tour guide": ["Legal expenses", "Excess sum insured"],
  "Tour operator": ["Excess sum insured", "Legal expenses"],
  "Tourism / Tour Attraction Shop": ["Legal expenses", "Include contents"],
  "Town planner": ["Legal expenses", "Include contents"],
  "Toy & Game Shop": ["Include stock online", "Include contents"],
  "Toy Wholesalers": ["Include buildings"],
  Trainer: ["Legal expenses", "Include contents"],
  Training: ["Legal expenses", "Excess sum insured"],
  Translator: ["Legal expenses", "Personal accident"],
  "Travel agency": ["Legal expenses", "Excess sum insured"],
  "Travel agent in Shops & retail": ["Include contents", "Excess sum insured"],
  "Trophies (Glass) Wholesalers": ["Personal accident", "Include stock online"],
  "Trophy Shop": ["Include stock online", "Include contents"],
  "Tv & Radio Shop": ["Business interruption", "Include contents"],
  "Tv and video installation": ["Legal expenses", "Excess sum insured"],
  "UPVC Window And Door Manufacturers And Installers": [
    "Personal accident",
    "Legal expenses",
  ],
  "Underwriting agent": ["Hospital cash plan", "Excess sum insured"],
  "Unlicensed Grocer": ["Include contents", "Include stock online"],
  "Upholstery & furniture repair": ["Legal expenses", "Personal accident"],
  "Upholstery Shop": ["Legal expenses", "Personal accident"],
  "Vacuum Cleaner Repair Shop": ["Include contents", "Include stock online"],
  "Vending machine operator": ["Legal expenses", "Include stock online"],
  "Venetian Blind Supplier": ["Personal accident", "Legal expenses"],
  "Video editor": ["Include contents", "Legal expenses"],
  "Videographer exc underwater and aerial": [
    "Include contents",
    "Legal expenses",
  ],
  "Village & community hall in Leisure trades": [
    "Include contents",
    "Excess sum insured",
  ],
  "Vintage Clothes Shop": ["Include stock online", "Include contents"],
  "Virtual assistant": ["Legal expenses", "Include contents"],
  "Warehouse/Wholesaler in Warehousing": [
    "Include contents",
    "Excess sum insured",
  ],
  "Watch & Clock Shop": ["Include contents", "Include stock online"],
  Watchmaker: ["Legal expenses", "Include stock online"],
  "Web Site Designer": ["Legal expenses", "Excess sum insured"],
  "Web marketing": ["Legal expenses", "Excess sum insured"],
  "Wedding Shop": ["Include stock online", "Include contents"],
  Welders: ["Personal accident", "Legal expenses"],
  "Well Being Shop": ["Include contents", "Include stock online"],
  "Wellbeing charity": ["Excess sum insured", "Personal accident"],
  "Wheelie bin cleaner": ["Personal accident", "Excess sum insured"],
  "Will writing": ["Legal expenses", "Excess sum insured"],
  "Window & Door Wholesaling Inc Fitting": [
    "Legal expenses",
    "Include stock online",
  ],
  "Window cleaner": ["Personal accident", "Excess sum insured"],
  "Wine And Spirit Merchant": ["Legal expenses", "Include stock online"],
  "Wine Bar": ["Include contents", "Include stock online"],
  "Wine Shop": ["Include stock online", "Include contents"],
  "Women's group": ["Legal expenses"],
  "Wooden Finished Goods Manufacturers": [
    "Legal expenses",
    "Include stock online",
  ],
  "Woodworking machinist": ["Legal expenses", "Include tools"],
  "Wool & Needlework": ["Include stock online", "Include contents"],
  "Wool Shop": ["Include stock online", "Include contents"],
};

export const getCoversByTrade = (
  trade: string | undefined,
): string[] | null => {
  if (!trade) return null;

  const selectedCovers = tradeCovers[trade];

  if (!selectedCovers) return null;
  return selectedCovers;
};
